import { watch } from "vue";
import { format, parse } from "date-fns";
import { useFeedStore } from "@facet/utils/store.js";

export function useQuerySync() {
    const store = useFeedStore();

    const init = () => {
        const params = new URLSearchParams(window.location.search);

        let hasActiveFilters = false;

        store.taxonomies.forEach(({ key }) => {
            const value = params.get(key);
            if (value) {
                store.filters[key] = value.split(",").map(Number);
                hasActiveFilters = true;
            }
        });

        const searchParam = params.get("keywords")
        if( searchParam ){
            store.search = searchParam.trim()
            hasActiveFilters = true;
        }

        if (hasActiveFilters) {
            store.isToggled = true;
        }

        if(store.postType === 'event'){
            const monthParam = params.get("month")
            if (monthParam) {
                // validate month param "YYYY-MM"
                try {
                    const parsed = parse(monthParam, "yyyy-MM", new Date())
                    if (!isNaN(parsed)) {
                        store.month = monthParam
                    } else {
                        store.setCurrentMonth()
                    }
                } catch {
                    store.setCurrentMonth()
                }
            } else {
                store.setCurrentMonth()
            }
        }

    };

    const sync = () => {
        watch(
            () => ({ ...store.filters, month: store.month, mode: store.mode, search: store.search }),
            (newFilters) => {
                const params = new URLSearchParams();

                store.taxonomies.forEach(({ key }) => {
                    if (store.filters[key]?.length) {
                        params.set(key, store.filters[key].join(","))
                    }
                })

                if( store.postType === 'event' ){
                    if (store.month) {
                        const current = format(new Date(), "yyyy-MM")
                        if (store.month !== current) {
                            params.set("month", store.month)
                        }
                    }
                }
                
                if(store.search){
                    params.set("keywords", store.search);
                }

                const newUrl = `${window.location.pathname}?${params.toString()}`
                window.history.pushState({}, "", newUrl)

            },
            { deep: true }
        );
    };

    return { init, sync };
}
